import { render, staticRenderFns } from "./IndexCurrent.vue?vue&type=template&id=04bb0480&scoped=true&"
import script from "./IndexCurrent.vue?vue&type=script&lang=js&"
export * from "./IndexCurrent.vue?vue&type=script&lang=js&"
import style0 from "./IndexCurrent.vue?vue&type=style&index=0&id=04bb0480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb0480",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDataTable,VIcon,VSelect,VSpacer,VToolbar})
